import React, {useCallback} from 'react';

import {MAX_FILTER_MENU_OPTIONS} from '../../FilterMenu/FilterMenu';
import {useLocalI18n} from '../../../../../../../data/hooks/i18nHooks';
import FilterButton from '../../FilterButton';
import strings from '../../BubblesFilter.i18n.csv';
import { useNetworkareaFilterCategory } from '../../../../../../../data/hooks/participant/useNetworkareaFilterCategory';
import { useParticipantsCategories } from '../../../../../../../data/hooks/participant/useParticipantsCategories';

const MoreFilters = props => {
    const {event, onFilterActivation} = props,
        category = useNetworkareaFilterCategory(event.id),
        categories = useParticipantsCategories(event.id),
        visible = categories.length - (category ? 1 : 0) > 0 || category?.options.length > MAX_FILTER_MENU_OPTIONS,
        i18n = useLocalI18n(strings),
        href = ['/events', event.id, 'participants', 'filter'].join('/'),
        label = category && categories.length ? i18n['more-filters.plural'] : i18n['more-filters.singular'];

    const handleClick = useCallback(() => {
        app.history.push(href);
    }, [event]);

    if (!visible) return null;
    if (href == app.history.location.pathname) return null;

    return (
        <FilterButton icon="/img/ellipsis-horizontal.png" event={event} onClick={handleClick}>
            {label}
        </FilterButton>
    );
};

export default MoreFilters;
